
<div class="profile-container">
  <div class="">
      <div class="profile-content"> 
          <div class="personal-details">


            <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getAllMaterialIssueByWildSearchWithIssueStatus(0,10)" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getAllMaterialIssueByWildSearchWithIssueStatus(0,10)"></i>
                  </div>
  
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
          
            <table class="table table-striped">
                <thead>
                    <tr>
              
                        <th style="width: 15%;">{{ 'material-issue.issueNo' | translate }}</th>
                        <th style="width: 15%;">{{ 'material-issue.issueDate' | translate }}</th>
                        <th style="width: 15%;">{{ 'material-issue.branchName' | translate }}</th>
                        <th style="width: 15%;">{{ 'material-issue.createdByUserName' | translate }}</th>
                        <th style="width: 15%;">{{ 'material-issue.createdDate' | translate }}</th>
                        <th style="width: 15%;">{{ 'material-issue.latestStatus' | translate }}</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let material of materials | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">
    
                    <p style="width: 15%">{{material.issueNo}}</p>
                    <p style="width: 15%"><span *ngIf="material.issueDate != 0 && material.issueDate != null">{{material.issueDate | date}}</span> <span *ngIf="material.issueDate == 0 || material.issueDate == null">--</span></p>
                    <p style="width: 15%">{{material.branchName}}</p>
                    <p style="width: 15%">{{material.createdByUserName}}</p>
                    <p style="width: 15%"><span *ngIf="material.createdDate != 0 && material.createdDate != null">{{material.createdDate | date}}</span><span *ngIf="material.createdDate == 0 || material.createdDate == null">--</span> </p>
                    <p style="width: 15%">{{material.latestStatus}}</p>           
                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                      <i *ngIf="actionControls.isView" (click)="getViewById(material.materialIssueId)" data-toggle="modal" data-target="#viewModal" class="bi bi-eye-fill"></i>
                    </p>                
                </div>
            </div>
    
    
            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>
    
            <div class="loader"  *ngIf="!isLoading && materials.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
                
            </div>
    
            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
    
      
        </div>
      </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header" *ngFor="let issue of singleissue">
      <span class="approved" *ngIf="issue.latestStatus != 'REJECTED'">{{issue.latestStatus}}</span>
      <span class="not-approved" *ngIf="issue.latestStatus == 'REJECTED'">{{issue.latestStatus}}</span>
    </div>
    <div class="modal-body" *ngFor="let issue of singleissue">
      <div [formGroup]="form">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                  <label>{{ 'material-issue.issueNo' | translate }}</label>
                  <input readonly formControlName="issueNo" type="number" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>{{ 'material-issue.issueDate' | translate }}</label>
                  <input readonly formControlName="issueDate" type="text" class="form-control">
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'material-issue.createdByUserName' | translate }}</label>
                <input readonly formControlName="createdByUserName" type="text" class="form-control">
            </div>

            <div class="col-md-6 col-lg-6">
              <label>{{ 'material-issue.createdDate' | translate }}</label>
              <input readonly formControlName="createdDate" type="text" class="form-control">
          </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <label>{{ 'material-issue.branchName' | translate }}</label>
              <input readonly formControlName="branchName" type="text" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
                <div *ngFor="let list of productSerialNoList;let i = index">
                  <div class="productList">
                    <div class="row">
                      <div class="col-md-3 col-lg-3">
                        <label for="">{{ 'material-issue.productName' | translate }}</label>
                        <input class="form-control" readonly  value="{{list.productName}}" type="text">
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <label for="">{{ 'material-issue.uomName' | translate }}</label>
                        <input class="form-control" readonly  value="{{list.uomName}}" type="text">
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <label for="">{{ 'material-issue.quantity' | translate }}</label>
                        <input class="form-control" readonly value="{{list.requestQty}}" type="text">
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <label for="">{{ 'material-issue.approvedQty' | translate }}</label>
                        <input class="form-control" [(ngModel)]="list.approveQty" value="{{list.approveQty}}" [ngModelOptions]="{standalone: true}" type="text">
                      </div>
                    </div>
                    <!-- <div class="productQty">
                      <input class="form-control" readonly value="{{list.productName}}" type="text">
                      <input class="form-control" readonly value="{{list.requestQty}}" type="text">
                      <input class="form-control" readonly value="{{list.uomName}}" type="text">
                      
                      <input class="form-control" (keyup)="addInfoObj(i,list.approveQty)" [(ngModel)]="list.approveQty" [ngModelOptions]="{standalone: true}" placeholder="enter quantity" type="number">
                      
                    </div> 
                    <div class="infoObj" *ngFor="let infoObj of list.infoObj;let j = index;let last = last">
                      <input type="number" placeholder="enter slNo" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].slNo">
                      <input type="text" placeholder="enter make" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].make">
                      <input type="text" placeholder="enter modal" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].modal">
                      <input type="date" placeholder="enter expiryDate" class="form-control">
                    </div> -->
                  </div>
                </div>
              </div>
          </div>
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 20%;">{{ 'material-issue.userId' | translate }}</th>
                  <th style="width: 30%;text-align: center;">{{ 'material-issue.issueStatus' | translate }}</th>
                  <th style="width: 50%;text-align: center;">{{ 'material-issue.updatedDate' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of issue.status; let i = index;let itemLast = last;">
                  <td style="width: 20%;">{{status.userId}}</td>
                  <td style="width: 40%;text-align: center;">{{status.issueStatus}}</td>
                  <td style="width: 40%;text-align: center;" ><span *ngIf="status.updatedDate != 0 && status.updatedDate != null">{{status.updatedDate | date : 'medium'}}</span> <span *ngIf="status.updatedDate == 0 || status.updatedDate == null">--</span></td>
                </tr>
              </tbody>
            </table>
        </div>
          <div class="modal-footer">
            <button type="button" (click)="rejectIssue()" *ngIf="issue.latestStatus == 'REQUESTED'"  class="btn btn-danger left" >{{ 'generic.reject' | translate }}</button>
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
            <button *ngIf="issue.latestStatus == 'REQUESTED'" (click)="approveIssue()" type="button"   class="btn btn-primary">{{ 'generic.approve' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
